import { HttpContextToken } from '@angular/common/http';


// Opt-outs from MiradiHttpInterceptor's global handling, set per request through
// a generated service's `options.context`. Unlike a flag on a shared service, a
// token cannot leak onto other requests in flight, and nothing reaches the server.

// The interceptor's own edit-status check, which must not wait behind the
// queued writes it is checking on.
export const BYPASS_HTTP_QUEUE = new HttpContextToken<boolean>(() => false);

// The caller reports every failure itself, so the interceptor rethrows the raw
// error: no toast, no generic 403 redirect, no session-expired dialog. Network
// retries and the account-level 403 redirects still apply.
export const HANDLE_ERRORS_LOCALLY = new HttpContextToken<boolean>(() => false);

// For a caller that renders its own "no access" state: the interceptor still
// rethrows the 403, but does not send the reader to /home-user over it.
export const SKIP_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(() => false);
